// Hizmet kayıtları → gün grupları (tarih + proje + lokasyon): liste satırı günün özeti, açılır panel günün hizmetleri
export const dayKey = (e) => `${e.entry_date}|${e.project_id}|${e.location_id}`;
const uniq = (arr) => [...new Set(arr.filter(Boolean))];

function summarize(g, allEntries, lockOf) {
  const main = g.items.filter((e) => !e.is_price_diff);
  const active = main.filter((e) => e.status === "Aktif");
  const ffOf = (e) => allEntries.filter((k) => k.is_price_diff && k.parent_entry_id === e.id && k.status !== "İptal").reduce((s, k) => s + (k.subcontractor_total || 0), 0);
  const ff = active.reduce((s, e) => s + ffOf(e), 0);
  const cust = active.reduce((s, e) => s + (e.customer_total || 0), 0);
  const sub = active.reduce((s, e) => s + (e.subcontractor_total || 0), 0) + ff;
  const profit = active.reduce((s, e) => s + (e.gross_profit || 0), 0) - ff;
  return {
    ...g, main, active, cust, sub, ff, profit,
    cancelled: main.filter((e) => e.status === "İptal"),
    subs: uniq(main.map((e) => e.subcontractor_name)),
    doers: uniq(main.map((e) => e.actual_subcontractor_name || e.subcontractor_name)),
    creators: uniq(main.map((e) => e.created_by)),
    createdAt: main[0]?.created_at,
    lock: main.map((e) => lockOf(e)).find(Boolean) || null,
    hasEdits: main.some((e) => (e.edit_log || []).length > 0),
    hasPersonnel: main.some((e) => e.personnel_id),
  };
}

export function groupByDay(visEntries, allEntries, lockOf) {
  const map = new Map();
  for (const e of visEntries) {
    const k = dayKey(e);
    if (!map.has(k)) map.set(k, { key: k, entry_date: e.entry_date, project_id: e.project_id, location_id: e.location_id, project_name: e.project_name, location_name: e.location_name, items: [] });
    map.get(k).items.push(e);
  }
  return [...map.values()].map((g) => summarize(g, allEntries, lockOf)).sort((a, b) => (b.entry_date || "").localeCompare(a.entry_date || ""));   // en yeni gün üstte (aynı gün: liste sırası)
}
